import { renderCvmResultsByte1Rows, renderCvmResultsByte2Rows, renderCvmResultsByte3Rows } from './renderers/CvmResultsRenderer'
import { renderTvrByte5Rows } from './renderers/TvrRenderer'
import { renderCtqByte1Rows } from './renderers/CtqRenderer'
import { renderDefaultRows } from './renderers/DefaultRenderer'


export const renderAllRows = (rows, byteIndex, pageKey, builderData, currentHexValue, handleCellClick) => {
  if (pageKey === 'cvmResults' && byteIndex === 1) {
    return renderCvmResultsByte1Rows(rows, byteIndex, builderData, currentHexValue, handleCellClick);
  }
  
  if (pageKey === 'cvmResults' && byteIndex === 2) {
    return renderCvmResultsByte2Rows(byteIndex, builderData, currentHexValue, handleCellClick);
  }
  
  if (pageKey === 'cvmResults' && byteIndex === 3) {
    return renderCvmResultsByte3Rows(byteIndex, builderData, currentHexValue, handleCellClick);
  }
  
  if (pageKey === 'ctq' && byteIndex === 1) {
    return renderCtqByte1Rows(rows, byteIndex, builderData, currentHexValue, handleCellClick);
  }
  
  if (pageKey === 'tvr' && byteIndex === 5) {
    return renderTvrByte5Rows(rows, byteIndex, builderData, currentHexValue, handleCellClick);
  }
  
  return renderDefaultRows(rows, byteIndex, pageKey, currentHexValue, handleCellClick);
}


